import React, { useState, Fragment } from 'react';
import ModalBox from './ModalBox';
import { UploadOutlined, LoadingOutlined } from '@ant-design/icons';
import { Image, Spin } from 'antd';
import { UploadMCIService } from '../../services/profile';
import { isPdf, openNotificationInToast } from '../../utilities';

const antIcon = <LoadingOutlined style={{ fontSize: 14, color: '#fff' }} spin />;

function MCIUpload(props) {
  const { MCIUploadModal, setMCIUploadModal, bodyStyles } = props;
  const [fileDetails, setFileDetails] = useState({ fileName: '', fileUrl: '', file: '' });
  const [fileError, setFileError] = useState('');
  const [spinLoader, setSpinLoader] = useState('');

  const handleMCIUploadChange = (e) => {
    let file = e.target.files[0];
    const isJpgOrPngOrPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type.includes('pdf');
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (isJpgOrPngOrPdf) {
      setFileDetails({ fileName: file.name, fileUrl: URL.createObjectURL(file), file: file });
      setFileError('');
      console.log('success');
    } else {
      setFileError('You can only upload JPG/PNG/PDF file!');
      return false;
    }
  };

  const handleMCIUpload = (e) => {
    e.preventDefault();
    if (fileDetails.fileName !== '') {
      setSpinLoader(true);
      const formData = new FormData();
      formData.append('medicalCertificate', fileDetails.file);

      UploadMCIService(formData)
        .then((response) => {
          openNotificationInToast('success', 'Success!', 'Medical Registration Certificate has been uploaded!');
          setSpinLoader(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          localStorage.removeItem('verifyMCI');
        })
        .catch((error) => {
          console.log(error);
          setSpinLoader(false);
          localStorage.removeItem('verifyMCI');
        });
    } else {
      setFileError('Please upload file!');
    }
  };

  return (
    <ModalBox title='Medical Registration Certificate' visible={MCIUploadModal} setVisible={setMCIUploadModal} className='changeModal'>
      <div style={bodyStyles}>
        <div>Please upload a clear picture or scanned copy of your Medical Registration Certificate. We will verify the certificate within 2 business days.</div>
        <div className='mciUploadButton'>
          <UploadOutlined />
          <span>Upload</span>
          <input type='file' onChange={handleMCIUploadChange} name='MCIUpload' title='' />
        </div>
        {fileError !== '' && <div className='error_text mt_5'>{fileError}</div>}
        {fileDetails.fileUrl !== '' && (
          <div className='mciPreview'>
            {isPdf(fileDetails.fileName) ? <iframe src={fileDetails.fileUrl} width='100%' height='100%'></iframe> : <Image src={fileDetails.fileUrl} alt='MCI Certificate' />}
          </div>
        )}

        <button onClick={handleMCIUpload} className='buttonPrimary' style={{ marginTop: 20 }}>
          {spinLoader ? (
            <Fragment>
              UPLOADING <Spin indicator={antIcon} />
            </Fragment>
          ) : (
            'UPLOAD'
          )}
        </button>
      </div>
    </ModalBox>
  );
}

export default MCIUpload;
